<template>
  <div class="footnote">
    <table>
      <tbody>
        <tr v-for="footnote in footnotes">
          <td>{{footnote}}</td>
          <td v-html="note[footnote]"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: [
      'footnotes'
    ],
    data() {
      return {
        note: {
          '1': '<i>\
                  <p class="zero-margin-before">\
                    Data Source: The BC Public Health Microbiology and Reference Laboratory (BCPHMRL) courtesy of the BC Centre for Disease Control (BCCDC). \
                    HIV screening tests conducted by the VIHA Laboratory are not included.\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitation: Repeat tests in individuals who test using various identifiers may not be identified and \
                    these individuals may be counted more than once. \
                  </p> \
                </i>',
          '2': '<i>\
                  Testing does not include point of care tests.\
                </i>',
          '3': '<i>Data Source: BCCDC. When present, “By Provider Address” is graphed as dashed line in same colour.</i>',
          '4': '<i>MSM=men who have sex with men; PWID=people who inject drugs; HET=heterosexual. NIR=No identified risk/exposure.</i>',
          '5': '<i>Data Source: BCCDC</i>',
          '6': '<i>MSM=men who have sex with men; PWID=people who inject drugs; HET=heterosexual. NIR=No identified risk/exposure.</i>',
          '7': '<i>\
                  <p class="zero-margin-before">\
                    Data is for the period 2019 Q3–2020 Q2.<br>\
                    Data Sources:<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                    If the most recent HA of residence is not updated then the designated HA may be incorrect.\
                  </p>\
                  <p class="zero-margin-before">\
                    NB: Transgender have been assigned to their biological sex.\
                  </p>\
                </i>',
          '8': '<i>\
                  <p class="zero-margin-before">\
                    Data is for the period 2019 Q3–2020 Q2.<br>\
                    Data Sources:<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                    If the most recent HA of residence is not updated then the designated HA may be incorrect. \
                  </p>\
                </i>',
          '9': '<i>\
                  <p class="zero-margin-before">\
                    Data is for the period 2019 Q3–2020 Q2.<br>\
                    Data Sources:<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">i</span> British Columbia Centre for Excellence Drug Treatment Program (DTP) Database (ARV use, VL and CD4 count).<br>\
                    <span style="display: -webkit-inline-box; width: 20px;">ii</span> Administrative data (ex. MSP billings; hospitalization data from the Discharge Abstract Database (DAD)).\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitations: HA assignment is based on the most recent HA of residence of the patient, if not available of the HIV-care provider.\
                    If the most recent HA of residence is not updated then the designated HA may be incorrect. \
                  </p>\
                </i>',
          '10': '<i>\
                  Data Source: British Columbia Centre for Excellence Drug Treatment Program (DTP) Database.<br> \
                  Limitations: CD4 cell count capture is approximately 80%.\
                </i>',
          '11': '<i>\
                  Each quarter’s data is calculated as the sum of the 4 quarters leading up to it. e.g. 2019 Q4 is calculated from 2019 Q2 – 2020 Q1.<br> \
                  NB: A score of 0 is the best score and a score of 4 or more is the worst score.\
                </i>',
          '12': '<i>\
                  Data Source: Drug Treatment Program Database Limitation: DTP participants are designated to an HA based on most current residence provided by the participant.\
                </i>',
          '13': '<i>\
                  Data Source: Drug Treatment Program Database Limitations: CD4 cell count data is approximately 80% complete.\
                </i>',
          '14': '<i>\
                  <p class="zero-margin-before">\
                    Data Source: Drug Treatment Program Database<br>\
                    Limitation: DTP participants are designated to an HA based on most current residence provided by the participant.\
                  </p>\
                  <p class="zero-margin-before">\
                    Definition:<br>‘On antiretroviral therapy’ defined as being on treatment in the current quarter\
                  </p>\
                </i>',
          '15': '<i>\
                  Active DTP participants: An individual who has had medication prescribed at least once in the preceding quarter.<br>\
                  Inactive DTP participants: Persons no longer prescribed drugs through the HIV/AIDS Drug Treatment Program in the last quarter.\
                </i>',
          '16': '<i>\
                  Data Source: Drug Treatment Program Database<br>\
                  Limitation: Prescription refill adherence is used as a proxy for patient adherence.\
                </i>',
          '17': '<i>\
                  <p class="zero-margin-before">\
                    Data Source: Drug Treatment Program Database<br>\
                    Limitation: DTP participants are designated to a HA based on most current residence provided by the participant. \
                  </p>\
                </i>',
          '18': '<i>\
                  <p class="zero-margin-before">\
                    Data Source: DTP AIDS cases are obtained from the Drug Treatment Program Database; BCCDC AIDS cases are obtained from the BCCDC;\
                    CD4<200 at ART initiation data came from the DTP database. Indicator 12 also reflects information from BC Vital Statistics. As this\
                    information is made available to BC-CfE, we use it to inform the development and refinement of this indicator\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitation: AIDS case reporting was investigated using 3 definitions: First, using AIDS cases reported in AIDS case report forms from the\
                    DTP; Second, using AIDS cases reported via the BCCDC and third, using a CD4 cell count of <200 cells/µL at time of ART initiation using\
                    DTP data. AIDS case reporting is passive in BC, thus; AIDS case reporting is not well captured. The DTP sends out AIDS reporting forms to\
                    physicians annually. The BCCDC uses DTP AIDS case reports as well as physician AIDS case reports made directly to the BCCDC. Interpreting\
                    AIDS case reports should be done with these limitations in mind. AIDS data is updated annually as very few AIDS cases reports are\
                    reported in general and trends would be difficult to notice if reported quarterly.\
                  </p>\
                </i>',
          '19': '<i>\
                  <p class="zero-margin-before">\
                    Data Source: BC Vital Statistics\
                  </p>\
                  <p class="zero-margin-before">\
                    Limitation:<br>\
                    1. DTP participants are designated to an HA based on most current residence provided by the participant.<br>\
                    2. Mortality data is updated annually<br>\
                    3. The most recent available data was used.\
                  </p>\
                </i>',
        }
      }
    }
  }
</script>

<style scoped>
  .footnote {
    margin-top: 20px;
    border-top: 1px solid black;
    max-width: 720px;
    font-size: 0.85em;
  }

  .footnote td{
    vertical-align: top;
  }

  .footnote tbody > tr > td:nth-child(1){
    width: 20px;
  }
</style>

<style>
  p.zero-margin-before {
    -webkit-margin-before: 0px;
  }
</style>



// WEBPACK FOOTER //
// Footnotes.vue?0fae8cbc